import { useGetZipCoverageQuery } from "rdx/modules/zips/endpoints";

const FIVE_DIGIT_ZIP = /^\d{5}$/;

export type BatteryOnlyCoverageT = {
  isCovered: boolean;
  isChecking: boolean;
};

export const useBatteryOnlyCoverage = (zip?: string | null): BatteryOnlyCoverageT => {
  const fiveDigit = (zip ?? "").trim().slice(0, 5);
  const isValidZip = FIVE_DIGIT_ZIP.test(fiveDigit);

  const { data, isFetching } = useGetZipCoverageQuery(fiveDigit, { skip: !isValidZip });

  return {
    isCovered: isValidZip && !!data?.batteryAvailable,
    isChecking: isValidZip && isFetching,
  };
};

export default useBatteryOnlyCoverage;
